import React, { Component } from 'react';
import { createAppContainer } from 'react-navigation';
import { createStackNavigator } from 'react-navigation-stack';
import PI from './PI';
import Success from './common/Success';
import WithOutQuote from './common/WithOutQuote';
import DocumentCollection from './common/DocumentCollection'
import QuoteInstructions from './common/QuoteInstructions'
import Camera from './common/Camera'
import PreviewImage from './common/PreviewImage'
import VideoRecorder from './common/VideoRecorder'
import VideoPreview from './common/VideoPreview'
import DocumentUpload from './common/DocumentUpload'
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import store from './redux/store';
import Colors from './common/Colors'




//AppNAvigator
const AppNavigator = createStackNavigator({
    Success: { screen: Success, navigationOptions: { headerShown: false } },
    WithOutQuote: { screen: WithOutQuote, navigationOptions: { headerShown: false } },
    DocumentCollection: { screen: DocumentCollection, navigationOptions: { headerShown: false } },
    // QuoteInstructions: { screen: QuoteInstructions, navigationOptions: { headerTitle: '', headerTintColor: Colors.darkBlack, headerStyle: { backgroundColor: Colors.lightBlack } } },
    QuoteInstructions: { screen: QuoteInstructions, navigationOptions: { headerShown: false } },

    PI: { screen: PI, navigationOptions: { headerShown: false } },
    Camera: { screen: Camera, navigationOptions: { headerShown: false } },
    PreviewImage: { screen: PreviewImage, navigationOptions: { headerShown: false } },
    VideoRecorder: { screen: VideoRecorder, navigationOptions: { headerShown: false } },
    VideoPreview: { screen: VideoPreview, navigationOptions: { headerShown: false } },
    DocumentUpload: { screen: DocumentUpload, navigationOptions: { headerShown: false } },
},
    {
        initialRouteName: "PI" //To Render From Here
    }

);


const AppContainer = createAppContainer(AppNavigator);

class App extends Component {
    render() {
        console.log(this.props.activityId)
        return (
            <Provider store={store}>
                <AppContainer
                    screenProps={{
                        activityId: this.props.activityId,
                        activityTypeId: this.props.activityTypeId,
                        webUserId: this.props.webUserId,
                        props: this.props
                    }}>
                </AppContainer>
            </Provider>

        )
    }

}
App.propTypes = {
    activityId: PropTypes.string,
    activityTypeId: PropTypes.string,
    webUserId: PropTypes.string,
};

App.defaultProps = {
    activityId: '-1',
    activityTypeId: '-1',
    webUserId: '-1',
};

export default App;